import Divider from "@components/common/divider";
import SectionDivider from "@components/SectionDivider";
import { getWidgetSpecificIsVisible, getWidgetSpecificProp, getWidgetSpecificProps } from "@utils/index";
import {
    FinalTotal,
    IDVSectionHeading,
    Price,
    SectionHeaderPrice,
    TotalSection
} from "@widgets/coveragePricingBreakup/styles";
import { connect } from "react-redux";
import { GrossPremiumPrice } from "./styles";

const mapStateToProps = function (state: any, ownProps: any) {
    return {
        is_visible: getWidgetSpecificIsVisible(
            state.configuration?.normalisedConfig,
            ownProps.id
        ),
        grossPremium: getWidgetSpecificProp(
            state.configuration?.normalisedConfig,
            ownProps.id,
            "grossPremium"
        ),
        premiumDetails: getWidgetSpecificProp(
            state.configuration?.normalisedConfig,
            ownProps.id,
            "premiumDetails"
        ),
    };
};

const ReviewPriceBreakup = (props) => {
    const { is_visible, grossPremium, premiumDetails, totalText } = props || {};

    if (!is_visible) {
        return null;
    }

    return (
        <>
            {
                premiumDetails?.length > 0 ? <>
                    <Divider
                        styles={{
                            borderTop: "2px dashed #efe9fb",
                            marginTop: "16px",
                            marginBottom: "0px"
                        }}
                    />
                    <TotalSection>
                        {premiumDetails?.map((premium) => {
                            const { key, value } = premium;
                            return (
                                <SectionHeaderPrice>
                                    <IDVSectionHeading>{key}</IDVSectionHeading>
                                    <Price>₹{value}</Price>
                                </SectionHeaderPrice>
                            );
                        })}
                    </TotalSection>
                </> : null
            }

            <Divider
                styles={{
                    borderTop: "2px dashed #efe9fb",
                    marginTop: "12px",
                    marginBottom: "0px"
                }}
            />
            <TotalSection
                style={{ flexDirection: "row", justifyContent: "space-between" }}
            >
                <FinalTotal>{totalText}</FinalTotal>
                <GrossPremiumPrice>₹{grossPremium}</GrossPremiumPrice>
            </TotalSection>
        </>
    );
};

export default connect(mapStateToProps)(ReviewPriceBreakup);
